import CategoryNewsCard from "./CategoryNewsCard";

export default function CategoryList({ newsPostedByAuthorData }) {
  return (
    <div className="space-y-6">
      {newsPostedByAuthorData?.map((item, index) => (
        <CategoryNewsCard
          key={index}
          image={item?.thumbnail}
          title={item?.title}
          desc={item?.excerpt}
          time={item?.date}
          href={item?.permalink}
          imageAlt={item?.thumbnail_alt}
          isVideo={item?.is_video}
        />
      ))}
    </div>
  );
}
